document.addEventListener('click', async function (event) {
  const link = event.target.closest(
    '[data-ajax-pagination] [data-ajax-pagination-links] a[href]'
  );

  if (!link) return;

  if (
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey ||
    event.altKey ||
    event.button !== 0
  ) {
    return;
  }

  const container = link.closest('[data-ajax-pagination]');
  if (!container) return;

  const sectionId = container.dataset.sectionId;
  if (!sectionId) return;

  event.preventDefault();

  const destinationUrl = new URL(link.href, window.location.origin);
  const requestUrl = new URL(destinationUrl.href);

  // Keep Shopify's page/phcursor parameters.
  // Only remove the anchor for the AJAX request.
  requestUrl.hash = '';

  // Request the section as JSON.
  requestUrl.searchParams.delete('section_id');
  requestUrl.searchParams.set('sections', sectionId);

  container.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(
      requestUrl.pathname + requestUrl.search,
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    );

    if (!response.ok) {
      throw new Error('AJAX pagination request failed');
    }

    const sections = await response.json();
    const sectionHtml = sections[sectionId];

    if (!sectionHtml) {
      throw new Error('Section HTML was not returned');
    }

    const parsed = new DOMParser().parseFromString(
      sectionHtml,
      'text/html'
    );

    const replacement =
      parsed.querySelector('[data-ajax-pagination]') ||
      parsed.querySelector('#ProductGridContainer');

    if (!replacement) {
      throw new Error('Updated product grid could not be found');
    }

    const scrollPosition =
      container.getBoundingClientRect().top +
      window.scrollY -
      20;

    container.replaceWith(replacement);

    window.history.pushState(
      {},
      '',
      destinationUrl.pathname + destinationUrl.search
    );

    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });

  } catch (error) {
    console.error('StafCo AJAX pagination:', error);

    // Standard Shopify pagination remains the fallback.
    window.location.href = link.href;
  }
});